import bindings from './keybindings/bindings.js';
import actions from './keybindings/actions.js';

export default {
	keybindings:{
		bindings:bindings,
		actions:actions
	},
};